import styled from "styled-components"

interface StyledProps {
  applyBorder?: boolean
}

export const Img = styled.img<StyledProps>`
  ${({theme, applyBorder}) =>
    applyBorder &&
    `
  border: 1px solid ${theme.colors.greys.black};
  border-radius: ${theme.spacing.one};
  `};
  height: 100%;
  max-width: 50%;
  margin: 0 auto;
`
